import { IContract } from "../services/bff/coordinator/dto/Contracts.dto"

export const isContractAccepted = (contract: IContract) => {
    return contract.proposals.some(proposal => proposal.wasAccepted)
}